import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { TemplateOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchTemplate(templateId: string): Promise<TemplateOut> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.GET_DYNAMIC_BONUS_TEMPLATE.replace("{template_id}", templateId);
  const response = await instance.get(url);
  const template = bonusAdminBody<TemplateOut>(response);
  if (!template) {
    throw new Error("Template not found");
  }
  return template;
}

export const getTemplateQueryKey = (templateId: string) =>
  ["GET_DYNAMIC_BONUS_TEMPLATE", templateId] as const;

export const useGetTemplate = (templateId: string) => {
  return useQuery<TemplateOut>({
    queryKey: getTemplateQueryKey(templateId),
    queryFn: () => fetchTemplate(templateId),
    enabled: Boolean(templateId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
